import stylesMediaText from '@components/media-text/MediaText.module.scss'

import Content from '@components/media-text/components/content/Content'
import { Product as ProductSku } from '@components/media-text/components/content/types'
import Heading from '@components/media-text/components/heading/Heading'
import Visual from '@components/media-text/components/visual/Visual'
import { usePbProps } from '@content/helpers/src/context'
import { useProducts } from '@content/helpers/src/contextProducts'
import { getProduct } from '@nespresso/catalog-sdk'
import { useEffect } from 'preact/hooks'

export default function PlaceholderShopTheLook({ onOpenModal, content }) {
    const { copywriting, campaign, layout }: any = usePbProps()

    const {
        title,
        description,
        image,
        cta,
        cta_secondary,
        products,
        promotion_details
    } = content || copywriting

    const { setProducts } = useProducts()

    async function getAllProducts(productIds: ProductSku[]) {
        const productRequests = productIds.map(p => getProduct(p))
        const productData = await Promise.all(productRequests)
        setProducts(productData)
    }

    useEffect(() => {
        getAllProducts(products)
    }, [products])

    // This is a temporary solution to handle the case where the place holders are not available in the CMS
    const placeholders =
        promotion_details?.promo_modal.collapseInfo.modalContainer
            ?.blocksDescription

    return (
        <>
            <div className={stylesMediaText['media-text__placeholder']}>
                <Visual
                    alt_text={image?.desktop?.alt}
                    desktop={image?.desktop?.src}
                    mobile={image?.mobile?.src}
                    retina={image?.retina?.src}></Visual>
            </div>
            <div className={stylesMediaText['media-text__content']}>
                <div>
                    <Heading title={title} />
                </div>
                <div>
                    <Content
                        contrast={layout.contrast}
                        onOpenModal={onOpenModal}
                        promotion_details={promotion_details}
                        campaign={campaign}
                        text={description}
                        buttonPrimary={cta}
                        buttonSecondary={cta_secondary}
                        products={products}
                        placeholders={
                            placeholders
                                ? JSON.parse(placeholders).placeholders
                                : null
                        }
                    />
                </div>
            </div>
        </>
    )
}
